import * as ApiManager from './_manager';
import store from '../store';

export const screening = {
  todayList: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/today`,
      payload,
    );
  },
  upcomingList: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/upcoming`,
      payload,
    );
  },
  ongoingList: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/ongoing`,
      payload,
    );
  },
  listVodEvents: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/vod`,
      payload,
    );
  },
  archiveList: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/archive`,
      payload,
    );
  },
  getStreamUrl: (payload) => {
    return ApiManager.callApi(
      `/guest/screenings/${store.getters['company/getCurrentCompanyId']}/media`,
      payload,
    );
  },
  getAndEnforce: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/getAndEnforce`,
      payload,
    );
  },
  getWithoutEnforce: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/getWithoutEnforce`,
      payload,
    );
  },
  get: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/get`,
      payload,
    );
  },
  markFirstWatch: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/vod/${payload.screener_id}/markFirstWatch`,
      payload,
    );
  },
  getSeatsStatus: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/${payload.screener_id}/getSeatsStatus`,
      payload,
    );
  },
  getExternalSrcUrl: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/${payload.screener_id}/${payload.film_id}/getExternalSrcUrl`,
      payload,
    );
  },

  getGeoGraphicalCatalogue: (payload) => {
    return ApiManager.callApi(
      `/guest/company/${store.getters['company/getCurrentCompanyId']}/screenings/get-geo-graphical-catalogue`,
      payload,
    );
  }
};
